import styled from 'styled-components';
import { Input, TextArea } from 'components/atoms/input';

export const CpInput = styled(Input)`
  border-bottom: 1px solid var(--cp-border-strong);
  background-color: white;

  font-weight: var(--cp-body-01-font-weight);
  font-size: var(--cp-body-01-font-size);
  line-height: var(--cp-body-01-line-height);
  color: var(--cp-text-primary);
  letter-spacing: var(--cp-body-01-letter-spacing);
  padding: 0 var(--cp-spacing-05);
  &::placeholder {
    color: var(--cp-black-opacity-50-hover);
  }

  &:focus {
    outline-color: var(--cp-blue-60);
    outline-width: 2px;
  }

  &:hover {
    background: var(--cp-gray-10);
  }
`;

export const CpTextArea = styled(TextArea)`
  border-bottom: 1px solid var(--cp-border-strong);
  background-color: white;

  font-weight: var(--cp-body-01-font-weight);
  font-size: var(--cp-body-01-font-size);
  line-height: var(--cp-body-01-line-height);
  color: var(--cp-text-primary);
  letter-spacing: var(--cp-body-01-letter-spacing);
  padding: var(--cp-spacing-03) var(--cp-spacing-05);

  &::placeholder {
    color: var(--cp-text-placeholder);
    margin-top: var(--cp-spacing-03);
  }

  &:focus {
    outline-color: var(--cp-blue-60);
    outline-width: 2px;
  }

  &:hover {
    background: var(--cp-gray-10);
  }
`;

export const SearchInput = styled(CpInput)`
  border-radius: var(--border-radius-small);
  border: 1px solid var(--cp-border-subtle);
  height: 48px;
  padding: 0 var(--cp-spacing-06);

  .ant-input-prefix {
    margin-right: var(--cp-spacing-03);
  }

  &.ant-input-affix-wrapper {
    height: 48px;
  }
  @media (max-width: 480px) {
    margin-bottom: var(--cp-spacing-05);
  }
  .ant-input-suffix {
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    transition: all 0.3s;
    border-radius: var(--border-radius-base);
    :hover {
      background: var(--cp-gray-20);
      cursor: pointer;
    }
  }
  input {
    font-size: var(--cp-body-01-font-size);
  }
`;
